import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../Store/Slices/AuthSlice";
import SessionExpireModal from "./SessionExpireModal";

const AutoLogout = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const timerRef = useRef(null);

 const LOGOUT_TIME = 5 * 60 * 60 * 1000; //5 hours


  // ===========================
  // PAGE REFRESH CHECK
  // ===========================
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const last = localStorage.getItem("lastActivity");

    if (last) {
      const diff = Date.now() - parseInt(last);

      if (diff > LOGOUT_TIME) {
        setShowModal(true);
      }
    }
  }, []);

  // ===========================
  // RESET TIMER FUNCTION
  // ===========================
  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    localStorage.setItem("lastActivity", Date.now());

    timerRef.current = setTimeout(() => {
      setShowModal(true);
    }, LOGOUT_TIME);
  };

  // ===========================
  // LOGOUT HANDLER
  // ===========================
  const handleLogout = () => {
    // 1. Popup close
    setShowModal(false);

    // 2. Timer clear
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // 3. Redux logout
    dispatch(logout());

    // 4. Storage clear
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("lastActivity");

    // 5. Redirect to login
    window.location.href = "/";
  };

  // ===========================
  // ACTIVITY LISTENER
  // ===========================
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const events = [
      "click",
      "keydown",
      "scroll",
      "mousemove",
      "mousedown",
      "touchstart",
    ];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });

      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <>
      {showModal && (
        <SessionExpireModal onConfirm={handleLogout} />
      )}
    </>
  );
};

export default AutoLogout;
